import React from 'react';
import Navbar from './components/Navbar';
import Hero from './sections/Hero';
import TrustBar from './sections/TrustBar';
import Products from './sections/Products';
import Features from './sections/Features';
import ProductDetails from './sections/ProductDetails';
import Modules from './sections/Modules';
import HowItWorks from './sections/HowItWorks';
import Stats from './sections/Stats';
import Pricing from './sections/Pricing';
import Contact from './sections/Contact';
import Footer from './components/Footer';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';


export default function App() {
  return (
    <Router basename="/microsite/">
      <Navbar />
      <Hero />
      <TrustBar />
      <Products />
      <Features />
      <ProductDetails />
      <Modules />
      <HowItWorks />
      <Stats />
      <Pricing />
      <Contact />
      <Footer />
    </Router>
  );
}
